import React from "react";
import { Text } from 'tea-component';
import { SelectorOption } from './types';

export const emptyFunc = () => {};

export const getCompanies = (list: any[]): string[] => {
  if (!Array.isArray(list)) return [];
  const result = [];
  let item;
  let companies;
  let company;
  for (let i = 0; i < list.length; i++) {
    item = list[i];
    if (!item) continue;
    companies = item.companyName;
    if (!companies) continue;
    companies = companies.trim().split('<SEP>');
    for (let j = 0; j < companies.length; j++) {
      company = companies[j];
      if (!company) continue;
      company = company.trim();
      result.push(company);
    }
  }
  return [...new Set(result)];
};

export const getSelectorOption = (value: string): SelectorOption => {
  return {
    value,
    text: React.createElement(
      'div',
      {
        className: 'databrain__region-item',
      },
      React.createElement(
        Text,
        {
          className: 'databrain__region-item-label'
        },
        value
      )
    ),
    tooltip: value,
  };
};
